// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Menu, Sidebar } from "semantic-ui-react";
import "./ApplicationLauncherList.less";
import { ApplicationLauncherContext } from "./ApplicationLauncherContext";
import { DomainLauncherList } from "../../entities/Domain";
import { getApplicationClassName } from "../utils/className";
import { jsx as _jsx } from "react/jsx-runtime";
const className = getApplicationClassName("launcher", "list");
export const ApplicationLauncherList = props => {
  const {
    open,
    setOpen
  } = React.useContext(ApplicationLauncherContext);
  const handleHidden = React.useCallback(() => {
    if (setOpen) {
      React.startTransition(() => {
        setOpen(false);
      });
    }
  }, [setOpen]);
  const handleShow = React.useCallback(() => {
    if (setOpen) {
      React.startTransition(() => {
        setOpen(true);
      });
    }
  }, [setOpen]);
  const menu = React.useMemo(() => /*#__PURE__*/_jsx(Menu, {
    secondary: true,
    inverted: true,
    borderless: true,
    fluid: true,
    stackable: true,
    children: /*#__PURE__*/_jsx(DomainLauncherList, {})
  }), []);
  return React.useMemo(() => /*#__PURE__*/_jsx(Sidebar, {
    className: className,
    as: Menu,
    animation: "overlay",
    direction: "top",
    visible: open,
    onHidden: handleHidden,
    onShow: handleShow,
    inverted: true,
    borderless: true,
    children: menu
  }), [open, menu, handleHidden, handleShow]);
};